<template>
    <div
        :class="classList"
        @click="onClick"
    >
        <template v-if="selectable">
            <div
                v-if="selected"
                class="afu-flex afu-items-center afu-flex-shrink-0 afu-flex-grow-0 afu-justify-center afu-h-4.5 afu-w-4.5 afu--ml-2 afu-mr-1 afu-rounded-full afu-bg-white afu-bg-opacity-25"
            >
                <span class="afu-text-xl afu-text-white">
                    <FontAwesomeIcon :icon="['far', 'check']" />
                </span>
            </div>

            <div
                v-else
                class="afu-flex afu-items-center afu-flex-shrink-0 afu-flex-grow-0 afu-justify-center afu-h-4.5 afu-w-4.5 afu--ml-2 afu-mr-1 afu-rounded-full afu-bg-neutral"
            >
                <span class="afu-text-xl afu-text-white">
                    <FontAwesomeIcon :icon="['far', 'plus']" />
                </span>
            </div>
        </template>

        <div class="af-tag-label afu-truncate">
            <slot />
        </div>

        <C1TagCloseBtn
            v-if="removable"
            :local-variant="localVariant"
            :is-outline="isOutline"
            @click="onRemove"
        />
    </div>
</template>

<script>
    import { VARIANTS } from './utils/variants';
    import C1TagCloseBtn from '@/components/C1Components/C1TagCloseBtn';

    export default {
        name: 'C1Tag',

        components: {
            C1TagCloseBtn,
        },

        props: {
            variant: {
                type: String,
                default: null,
                validator: value => VARIANTS.includes(value),
            },

            removable: {
                type: Boolean,
                default: false,
            },

            selectable: {
                type: Boolean,
                default: false,
            },

            selected: {
                type: Boolean,
                default: false,
            },
            size: {
                type: String,
                default: 'md',
            },
        },

        computed: {
            classList() {
                return [
                    this.getDefaultClass,
                    this.getTextColorClass,
                    this.getTextSizeClass,
                    this.getBorderColorClass,
                    this.getBgColorClass,
                    this.getCursorClass,
                ];
            },

            getDefaultClass() {
                let output = ['af-tag'];
                if (this.localVariant) {
                    output.push(`af-tag-${this.localVariant}`);
                }

                output.push('afu-inline-flex afu-items-center afu-rounded-btn afu-border afu-border-solid afu-font-medium afu-max-w-full afu-mb-2.5 afu-mr-1 afu-px-2.5 afu-py-0.5 afu-transition afu-ease-in-out afu-duration-150');

                return output.join(' ');
            },

            getTextColorClass() {
                if (this.localVariant == 'neutral') {
                    return 'afu-text-secondary';
                }

                if (this.isOutline) {
                    return `afu-text-${this.localVariant}`;
                }

                return this.localVariant ? 'afu-text-white' : 'afu-text-black hover:afu-text-black';
            },

            getTextSizeClass() {
                if(this.size == 'sm') {
                    return 'afu-text-base afu-font-bold afu-leading-base';
                }

                return 'af-text--lg';
            },

            getBorderColorClass() {
                let output = [];

                if (this.localVariant) {
                    output.push(`focus:afu-border-${this.localVariant}`);
                }

                if (this.isOutline) {
                    output.push(`afu-border-${this.localVariant}`);
                } else {
                    output.push('afu-border-transparent');
                }

                return output.join(' ');
            },

            getBgColorClass() {
                if (this.isOutline) {
                    return 'afu-bg-white';
                }

                if (!this.localVariant) {
                    return 'afu-bg-neutral';
                }

                let output = [
                    `afu-bg-${this.localVariant}`,
                    `afu-bg-${this.localVariant}`,
                    'focus:afu-border-blur-500',
                    `active:afu-bg-${this.localVariant}`,
                ];

                if (this.selectable || this.removable) {
                    output.push(`hover:afu-bg-${this.localVariant}`);
                }

                return output.join(' ');
            },

            getCursorClass() {
                return this.selectable || this.removable ? 'afu-cursor-pointer' : '';
            },

            isOutline() {
                return this.variant ? this.variant.startsWith('outline') : false;
            },

            localVariant() {
                return this.variant ? this.variant.replace('outline-',  '') : null;
            },
        },

        methods: {
            onRemove() {
                this.$emit('remove');
            },

            onClick() {
                if (!this.selectable) {
                    return;
                }

                this.$emit('click', !this.selected);
            },
        },
    };
</script>
